export default "__VITE_ASSET__C9Uk2fn7__"